import { render, staticRenderFns } from "./MedicalRecordCompany.vue?vue&type=template&id=5756160c&scoped=true"
import script from "./MedicalRecordCompany.vue?vue&type=script&lang=js"
export * from "./MedicalRecordCompany.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecordCompany.vue?vue&type=style&index=0&id=5756160c&prod&lang=scss"
import style1 from "./MedicalRecordCompany.vue?vue&type=style&index=1&id=5756160c&prod&lang=scss&scoped=true"
import style2 from "./MedicalRecordCompany.vue?vue&type=style&index=2&id=5756160c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756160c",
  null
  
)

export default component.exports